<app-navbar></app-navbar>
<div class="container-flex">
    <div class="my-container">
        <div class="section-title-container">
            <div class="row">
                <h3 class="info-title">
                    Documentos del PARLACEN
                    <button class="btn btn-success btn-sm ml-2" data-toggle="modal" data-target="#add-document">
                        Agregar
                    </button>
                    <button class="btn btn-success btn-sm ml-2" (click)="listarDocumentos()">
                        Refrescar tabla
                    </button>
                </h3>
                <button type="button" class="btn btn-outline-dark outline-leer-mas">
                    <a class="nav-link" routerLink="/inicio">Inicio</a>
                </button>
            </div>
        </div>
        <div class="section-body-container">
            <div class="m-5 p-5" *ngIf="!plenaryDocs || !plenaryDocs?.length">

            </div>
            <table class="news-table table table-striped table-borderless table-responsive table-hover"
                *ngIf="plenaryDocs && plenaryDocs?.length">
                <caption class="sr-only">Noticias del Parlamento Centroamericano</caption>
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Título</th>
                        <th scope="col">Description</th>
                        <th scope="col">Documento</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of plenaryDocs | slice: (page - 1) * pageSize : (page - 1) * pageSize + pageSize; let i = index;"
                        class="info-text">
                        <th scope="row">{{ i + 1 }}</th>
                        <td>{{ item.name }}</td>
                        <td>{{ item.title }}</td>
                        <td>{{ item.description }}</td>
                        <td class="text-sky-blue">
                            <a [href]="cleanURL(item.document)" target="blank">
                                {{ item.name }}
                                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-paperclip"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z" />
                                </svg>
                            </a>
                        </td>
                        <td class="text-center d-flex">
                            <div class="mr-1">
                                <button class="btn btn-primary btn-sm mt-1" data-toggle="modal" data-target="#view-news"
                                    (click)="setDoc(item)">
                                    Ver
                                </button>
                            </div>
                            <div class="mr-1">
                                <button class="btn btn-warning btn-sm mt-1" data-toggle="modal"
                                    data-target="#udpate-document" (click)="setDoc(item)">
                                    Actualizar
                                </button>
                            </div>
                            <div>
                                <button class="btn btn-danger btn-sm mt-1" data-toggle="modal"
                                    data-target="#delete-news" (click)="setDoc(item)">
                                    Eliminar
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <ngb-pagination class="d-flex justify-content-center" [collectionSize]="plenaryDocs?.length" [(page)]="page"
                [boundaryLinks]="true" [pageSize]="pageSize" size="sm" [maxSize]="5" [rotate]="true"
                *ngIf="plenaryDocs && plenaryDocs?.length">
            </ngb-pagination>
        </div>
    </div>
</div>
<div class="text-center spinner-container" *ngIf="loading">
    <div class="spinner-border text-primary text-center" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<!-- Add Document ∆ Modal ∆ -->
<div class="modal fade" id="add-document" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="add-document-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #addDocument="ngForm" (submit)="agregarDocumento()">
                <div class="modal-header text-center  p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="add-document-title">
                        Agregar Documento
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cleanDoc()">
                        <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="add-name" class="group-title pb-1">
                            Nombre
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="add-name" #name="ngModel"
                            [(ngModel)]="plenaryDoc.name" name="name" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-title" class="group-title pb-1">
                            Título
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="add-title" #title="ngModel"
                            [(ngModel)]="plenaryDoc.title" name="title" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-type" class="group-title pb-1">
                            Tipo de Documento
                            <small style="color: red;">*</small>
                        </label>
                        <select class="form-control" id="add-type" #type="ngModel" [(ngModel)]="plenaryDoc.type"
                            name="type" required aria-required="true" [disabled]="isSubmitting">
                            <option *ngFor="let type of docTypes" [value]="type">{{type}}</option>
                        </select>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-year" class="group-title pb-1">
                            Año de Publicación
                            <small style="color: red;">*</small>
                        </label>
                        <input type="number" class="form-control" id="add-year" #year="ngModel"
                            [(ngModel)]="plenaryDoc.year" name="year" required aria-required="true"
                            [readonly]="isSubmitting" min="1900" minlength="4">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-description" class="group-title pb-1">
                            Breve descripción
                            <small style="color: red;">*</small>
                        </label>
                        <textarea type="description" class="form-control" id="add-description" #description="ngModel"
                            [(ngModel)]="plenaryDoc.description" name="description" required aria-required="true"
                            [readonly]="isSubmitting" rows="3">
                        </textarea>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-description" class="group-title pb-1">
                            Visible en la web
                            <small style="color: red;">*</small>
                        </label><br>
                        <input type="radio" [value]="'ACTIVO'" name="gender" [(ngModel)]="plenaryDoc.status"> Sí
                        <input type="radio" [value]="'INACTIVO'" name="gender" [(ngModel)]="plenaryDoc.status"> No
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-doc" class="group-title pb-1">
                            Archivo
                            <small style="color: red;">*</small>
                        </label>
                        <div class="input-group">
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="add-doc" [disabled]="isSubmitting"
                                    (change)="onFileChange($event, 0)">
                                <label class="custom-file-label" id="add-doc-label" for="add-doc">
                                    Buscar Archivo
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cleanDoc()"
                        [disabled]="isSubmitting">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-primary" type="submit" [disabled]="isSubmitting">
                        Agregar Documento
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- View Document ∆ Modal ∆ -->
<div class="modal fade" id="view-news" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="view-news-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header text-center  p-4 bg-dark">
                <h5 class="modal-title group-title w-100 text-white" id="view-news-title">
                    Ver Documento
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cleanDoc()">
                    <span aria-hidden="true" class="text-white">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group pb-4">
                    <label for="view-name" class="group-title pb-1">
                        Nombre
                    </label>
                    <input type="text" class="form-control" id="view-name" [value]="plenaryDoc.name" readonly>
                </div>
                <div class="form-group pb-4">
                    <label for="view-title" class="group-title pb-1">
                        Título
                    </label>
                    <input type="text" class="form-control" id="view-title" [value]="plenaryDoc.title" readonly>
                </div>
                <div class="form-group pb-4">
                    <label for="view-type" class="group-title pb-1">
                        Tipo de documento
                    </label>
                    <input type="text" class="form-control" id="view-type" [value]="plenaryDoc.type" readonly>
                </div>
                <div class="form-group pb-4">
                    <label for="view-year" class="group-title pb-1">
                        Año de Publicación
                    </label>
                    <input type="number" class="form-control" id="view-year" [value]="plenaryDoc.year" readonly>
                </div>
                <div class="form-group pb-4" *ngIf="plenaryDoc.description">
                    <label for="view-description" class="group-title pb-1">Breve descripción</label>
                    <textarea type="description" class="form-control" id="view-description"
                        [value]="plenaryDoc.description" readonly rows="9">
                    </textarea>
                </div>
                <div class="form-group pb-4">
                    <label for="add-description" class="group-title pb-1">
                        Visible en la web
                        <small style="color: red;">*</small>
                    </label><br>
                    <input type="radio" [value]="'ACTIVO'" name="gender" [(ngModel)]="plenaryDoc.status" disabled> Sí
                    <input type="radio" [value]="'INACTIVO'" name="gender" [(ngModel)]="plenaryDoc.status" disabled> No
                </div>
                <div class="form-group pb-4 d-block">
                    <label class="group-title pb-1">
                        Archivo
                    </label>
                    <br>
                    <iframe [title]="plenaryDoc.title" style="width:100%; height:500px;"
                        [src]="cleanURLResource(plenaryDoc.document)">
                    </iframe>
                    <br>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cleanDoc()">
                    Salir
                </button>
            </div>
        </div>
    </div>
</div>


<!-- Delete Document ∆ Modal ∆ -->
<div class="modal fade" id="delete-news" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="delete-news-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #deleteDocument="ngForm" (submit)="eliminarDocumento()">
                <div class="modal-header text-center  p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="delete-news-title">
                        Eliminar Documento
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cleanDoc()">
                        <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="delete-title" class="group-title pb-1">
                            Título
                        </label>
                        <input type="text" class="form-control" id="delete-title" [value]="plenaryDoc.title" readonly>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 text-center">
                            <p class="info-text">
                                ¿Está seguro de que desea eliminar este documento?
                            </p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" (click)="cleanDoc()"
                        [disabled]="isDeleting">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-sm btn-danger" type="submit" [disabled]="isDeleting">
                        Eliminar
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Update Document ∆ Modal ∆ -->
<div class="modal fade" id="udpate-document" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="udpate-document-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #updateDocument="ngForm" (submit)="actualizarDocumento()">
                <div class="modal-header text-center  p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="update-document-title">
                        Actualizar Documento
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cleanDoc()">
                        <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="update-name" class="group-title pb-1">
                            Nombre
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="update-name" #name="ngModel"
                            [(ngModel)]="plenaryDoc.name" name="name" required aria-required="true"
                            [readonly]="isUpdating">
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-title" class="group-title pb-1">
                            Título
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="update-title" #title="ngModel"
                            [(ngModel)]="plenaryDoc.title" name="title" required aria-required="true"
                            [readonly]="isUpdating">
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-type" class="group-title pb-1">
                            Tipo de Documento
                            <small style="color: red;">*</small>
                        </label>
                        <select class="form-control" id="update-type" #type="ngModel" [(ngModel)]="plenaryDoc.type"
                            name="type" required aria-required="true" [disabled]="isUpdating">
                            <option *ngFor="let type of docTypes" [value]="type">{{type}}</option>
                        </select>
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-year" class="group-title pb-1">
                            Año de Publicación
                            <small style="color: red;">*</small>
                        </label>
                        <input type="number" class="form-control" id="update-year" #year="ngModel"
                            [(ngModel)]="plenaryDoc.year" name="year" required aria-required="true"
                            [readonly]="isUpdating">
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-description" class="group-title pb-1">
                            Breve descripción
                            <small style="color: red;">*</small>
                        </label>
                        <textarea type="description" class="form-control" id="update-description" #description="ngModel"
                            [(ngModel)]="plenaryDoc.description" name="description" required aria-required="true"
                            [readonly]="isUpdating" rows="3">
                        </textarea>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-description" class="group-title pb-1">
                            Visible en la web
                            <small style="color: red;">*</small>
                        </label><br>
                        <input type="radio" [value]="'ACTIVO'" name="gender" [(ngModel)]="plenaryDoc.status"> Sí
                        <input type="radio" [value]="'INACTIVO'" name="gender" [(ngModel)]="plenaryDoc.status"> No
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-doc" class="group-title pb-1">
                            Documento
                            <small style="color: red;">*</small>
                            <a [href]="cleanURL(plenaryDoc.document)" target="blank">
                                {{ plenaryDoc.name }}
                                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-paperclip"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z" />
                                </svg>
                            </a>
                        </label>
                        <div class="input-group">
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="update-doc" aria-describedby="doc-desc"
                                    (change)="onFileChange($event, 0)" [disabled]="isUpdating">
                                <label class="custom-file-label" id="update-doc-label" for="update-doc">
                                    Buscar Documento
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cleanDoc()"
                        [disabled]="isUpdating">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-warning" type="submit" [disabled]="isUpdating">
                        Actualizar Documento
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>